module.exports = __webpack_public_path__ + "static/media/ST 6.dc0ea8cb.jpg";